/* eslint-disable camelcase */
import { Box } from "@mui/material";
import React, { useEffect } from "react";

import { useUpdateDetectorNoteReview } from "api/services/useDetectorStats";
import { useNotes } from "api/services/useNotes";
import { ImageQueryPreview, PageContext } from "components/detector/ImageQueryPreview";
import { DETECTOR_DETAILS_REFRESH_TIME } from "config/constants";
import { useAppSelector } from "hooks/store";
import { useRefreshCount } from "hooks/useRefreshCount/useRefreshCount";
import { Typography } from "new-components/typography/Typography";
import { getUserState } from "store/slices/Auth/authSlice";
import { Detector } from "types/detectors";
import { NoteOwner } from "types/notes";

import { NotesSection } from "./NotesSection/NotesSection";

export interface NotesContentProps {
  detector: Detector;
  ownerGroupId: string | undefined;
  ownerGroupName: string | undefined;
}

export function NotesContent(props: NotesContentProps) {
  const { detector, ownerGroupId, ownerGroupName } = props;
  const { count } = useRefreshCount(DETECTOR_DETAILS_REFRESH_TIME);
  const { notes: notesData, isLoadingNotes } = useNotes({ detectorId: detector.id });
  const userData = useAppSelector(getUserState);
  const { mutate: updateNoteReview } = useUpdateDetectorNoteReview(detector.id);

  useEffect(() => {
    updateNoteReview();
  }, [updateNoteReview]);

  const isOwner = !!userData.groups.find((group) => group.id === ownerGroupId);
  const isGroundightUser = !isOwner && userData.can_edit_gl_notes;

  const noteSectionsOrder: [NoteOwner, NoteOwner] = isGroundightUser
    ? [NoteOwner.GL, NoteOwner.CUSTOMER]
    : [NoteOwner.CUSTOMER, NoteOwner.GL];

  return (
    <>
      <NotesSection
        detectorId={detector.id}
        notesData={notesData?.[noteSectionsOrder[0]]}
        ownerNote={noteSectionsOrder[0]}
        ownerGroupId={ownerGroupId}
        ownerGroupName={ownerGroupName}
        isLoadingNotes={isLoadingNotes}
      />
      <Box sx={{ my: "20px" }} />
      <NotesSection
        detectorId={detector.id}
        notesData={notesData?.[noteSectionsOrder[1]]}
        ownerNote={noteSectionsOrder[1]}
        ownerGroupId={ownerGroupId}
        ownerGroupName={ownerGroupName}
        isLoadingNotes={isLoadingNotes}
      />

      {detector && (
        <Box sx={{ my: "20px" }}>
          <Typography variant="title" color="#49494D">
            Examples:
          </Typography>

          <ImageQueryPreview
            detector={detector}
            count={count}
            pageContext={PageContext.DetectorDetails}
            columns={4}
            areExamples
            isActivityOnly
          />
        </Box>
      )}
    </>
  );
}
